export default {"src":"/_next/static/media/backArrow.fdc79e34.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};